import React, { useState, lazy } from "react";
import Suspense from "../../suspense";
import { Context } from "../../context";
import { getImage } from "gatsby-plugin-image";
import Image from "./image";
import NavGrid from "./navgrid";
require("../../../styles/gallery.scss");
const Gallery = (props) => {
    const { allImages, settings } = React.useContext(Context);
    const [isOpen, setIsOpen] = useState(false);
    const [activeImage, setActiveImage] = useState(0);
    const openModal = (index) => {
        setIsOpen(true);
        setActiveImage(index);
    };
    const getImgUrl = (id) => {
        const targetImage = allImages.find((e) => {
            return e.databaseId.toString() === id.toString();
        });
        if (targetImage) {
            const images = getImage(targetImage.localFile.childImageSharp.smallmore)
                .images.fallback;
            return images.src;
        }
        return id;
    };
    if (props.attributes.variation === "navgrid") {
        return (React.createElement(NavGrid, { ...props, navGridAsBackgroundImages: settings.metadata.navGridAsBackgroundImages, navGridTitleForButton: settings.metadata.navGridTitleForButton, innerBlocks: props.innerBlocks.map((e) => {
                e.url = getImgUrl(e.attributes.id);
                return e;
            }) }));
    }
    //  Carousel
    if (props.attributes.variation === "carousel") {
        let className = `wp-block-carousel ${props.attributes.className || ""}`;
        if (props.attributes.align && props.attributes.align.length) {
            className += " align" + props.attributes.align;
        }
        className += props.attributes.carouselNavigation
            ? ` ${props.attributes.carouselNavigation}`
            : " boutons";
        const GalleryCarousel = lazy(() => import("./gallery-carousel"));
        return (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement(GalleryCarousel, { style: props.style, id: props.anchor || props.attributes.anchor, className: className, openingModal: true, fixedImageNumber: false, isOpen: isOpen, setIsOpen: setIsOpen, typeButton: props.attributes.carouselNavigation || "boutons", activeImage: activeImage, setActiveImage: setActiveImage, content: props.innerBlocks, type: props.type })));
    }
    // Gallery
    let className = `wp-block-gallery ${props.attributes.className || ""}`;
    if (props.attributes.align && props.attributes.align.length) {
        className += " align" + props.attributes.align;
    }
    const GalleryModal = className.includes("has-modal")
        ? lazy(() => import("./gallery-modal"))
        : () => {
            return React.createElement(React.Fragment, null);
        };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: props.anchor || props.attributes.anchor, className: className, style: props.style },
            props.innerBlocks.map((image, i) => {
                return (React.createElement(Image, { attributes: image.attributes, size: "small", key: i, onClick: () => openModal(i) }));
            }),
            React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
                React.createElement(GalleryModal, { isOpen: isOpen, setIsOpen: setIsOpen, activeImage: activeImage, setActiveImage: setActiveImage, content: props.innerBlocks })))));
};
export default Gallery;
